import React, { useEffect, useState } from "react";
import styles from "./Select.module.css";
import { useSelector } from "react-redux";
import { handleResetState } from "../../Action/actions";
import { initialState } from "../../Reducer/atomizerPageReducer";
import { store } from "../../Store/store";
import VizParagraph from "../VizParagraph/VizParagraph";
import { Select } from "antd";

export default function HtmlSelect({
  type,
  selectfrequency,
  selectTypes,
  selectState,
  handleChangeType,
  selectFrequencyValue,
  handleChangeFrequencyValue,
  loading,
}) {
  const state = useSelector((state) => state.atomizer);
  function renderSelectType() {
    switch (type) {
      case "frequency":
        return selectfrequency;
      default:
        return selectTypes;
    }
  }
  function renderSelectValue() {
    switch (type) {
      case "frequency":
        return selectFrequencyValue;
      default:
        return selectState;
    }
  }

  const renderOnchange = (e) => {
    // console.log("e",e)
    switch (type) {
      case "frequency":
        return handleChangeFrequencyValue;
      default:
        return handleChangeType;
      // break;
    }
  };

  useEffect(() => {
    store.dispatch(handleResetState(initialState));
  }, [state?.sourceType]);

const options = renderSelectType().map(item => ({
  label: item.value,
  value: item.value
}));
  return (
    <>
      {/* <VizParagraph type={3}> */}
        {/* <select
          width="100%"
          className={styles.select}
          defaultValue={state?.sourceType}
          value={renderSelectValue()}
          onChange={renderOnchange()}
          disabled={loading ? true : false}
        >
          {renderSelectType()?.map((item, index) => {
            return (
              <option
                key={item?.key + index}
                value={item?.value}
                // className={styles.optionChange}
              >
                {item?.value}
              </option>
            );
          })}
        </select> */}
        <Select
              labelInValue
              showSearch
              options={options}
              value={renderSelectValue()}
              defaultValue={state?.sourceType}
              onChange={renderOnchange()}
              dropdownStyle={{ zIndex: 0, textAlign: "left" }}
              // placeholder="Select Group"
              // popupClassName={Styles.selectCss} 
              size="middle"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }

              disabled={loading ? true : false}
              style={{width:"100%",border:'none', boxShadow:'0px 1px 2px 0px #1018280D',fontSize:'16px',height:"31px"    }}
              // size={"medium"}
              // width={"100px"}
            />
      {/* </VizParagraph> */}
    </>
  );
}
